import { cva, type VariantProps } from 'class-variance-authority'
import { type HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

/**
 * Small status pill. Same colour vocabulary as the driver app —
 * we want the same "Bon rempli" / "En attente" badges to look
 * identical on both surfaces so an admin watching their dashboard
 * recognises what the chauffeur is filing.
 */

const badgeVariants = cva(
  cn(
    'inline-flex items-center gap-1',
    'px-2 py-0.5 rounded-full text-xs font-medium',
    'whitespace-nowrap',
  ),
  {
    variants: {
      tone: {
        info: 'bg-info-soft text-info',
        success: 'bg-success-soft text-success',
        warning: 'bg-warning-soft text-warning',
        danger: 'bg-danger-soft text-danger',
        template: 'bg-template-soft text-template',
        neutral: 'bg-surface-muted text-text-muted',
      },
    },
    defaultVariants: {
      tone: 'neutral',
    },
  },
)

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ tone, className, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />
}
